/* src/app.svelte generated by Svelte v4.1.1 */
import {
	SvelteComponent,
	create_component,
	destroy_component,
	detach,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import "svelte/internal/disclose-version";
import { PuzzleEditor, PuzzleDisplay, Consent } from "core";

function create_fragment(ctx) {
	let consent;
	let t0;
	let puzzleeditor;
	let t1;
	let puzzledisplay;
	let current;
	consent = new Consent({});
	puzzleeditor = new PuzzleEditor({});
	puzzledisplay = new PuzzleDisplay({});

	return {
		c() {
			create_component(consent.$$.fragment);
			t0 = space();
			create_component(puzzleeditor.$$.fragment);
			t1 = space();
			create_component(puzzledisplay.$$.fragment);
		},
		m(target, anchor) {
			mount_component(consent, target, anchor);
			insert(target, t0, anchor);
			mount_component(puzzleeditor, target, anchor);
			insert(target, t1, anchor);
			mount_component(puzzledisplay, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(consent.$$.fragment, local);
			transition_in(puzzleeditor.$$.fragment, local);
			transition_in(puzzledisplay.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(consent.$$.fragment, local);
			transition_out(puzzleeditor.$$.fragment, local);
			transition_out(puzzledisplay.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) {
				detach(t0);
				detach(t1);
			}

			destroy_component(consent, detaching);
			destroy_component(puzzleeditor, detaching);
			destroy_component(puzzledisplay, detaching);
		}
	};
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default App;